import { render, staticRenderFns } from "./Opciones.vue?vue&type=template&id=7db712f7&scoped=true"
import script from "./Opciones.vue?vue&type=script&lang=js"
export * from "./Opciones.vue?vue&type=script&lang=js"
import style0 from "./Opciones.vue?vue&type=style&index=0&id=7db712f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db712f7",
  null
  
)

export default component.exports